import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Input, Label } from "reactstrap";

const CertificateTypeSelector = ({ initialType, onSubmit, certificateId }) => {
  const [certificateType, setCertificateType] = useState("");
  const [error, setError] = useState("");

  // ✅ Auto-select type on edit mode or when initialType changes
  useEffect(() => {
    if (initialType) {
      const lowerType = initialType.toLowerCase();
      setCertificateType(lowerType);
      onSubmit(lowerType); // Ensure parent knows selected type
    }
  }, [initialType, certificateId]); // certificateId is optional but helpful for clarity

  const handleChange = (e) => {
    const value = e.target.value.toLowerCase();
    setCertificateType(value);
    console.log("Selected certificate type in selector:", value);

    if (!value) {
      setError("Certificate type is required");
    } else {
      setError("");
      onSubmit(value);
    }
  };

  return (
    <Card>
      <CardBody>
        <Col md={6} className="mx-auto">
          <Label htmlFor="certificateType">
            Select Certificate Type <span className="text-danger">*</span>
          </Label>
          <Input
            type="select"
            id="certificateType"
            name="certificateType"
            value={certificateType}
            onChange={handleChange}
            className="form-select"
            invalid={!!error}
            disabled={!!certificateId} // Disable in edit mode
          >
            <option value="">-- Select --</option>
            <option value="internship">Internship</option>
            <option value="appreciation">Appreciation</option>
            <option value="achievement">Achievement</option>
            <option value="hackathon_winner">Hackathon Winner</option>
            <option value="hackathon_participation">Hackathon Participation</option>
            <option value="most_valuable_person">Most Valuable Person (MVP)</option>
            <option value="best_team">Best Team</option>
            <option value="leaders_choice">Leader’s Choice</option>
            <option value="great_work">Great Work</option>
            <option value="star_of_the_month">Star of the Month</option>
            <option value="star_of_the_quarter">Star of the Quarter</option>
            <option value="star_performer">Star Performer</option>
            <option value="course_completion">Course Completion</option>
            <option value="training_completion">Training Completion</option>
          </Input>
          {error && <div className="invalid-feedback d-block">{error}</div>}
        </Col>
      </CardBody>
    </Card>
  );
};

export default CertificateTypeSelector;
